// Fixed Swiss grid: faint column rules aligned to the page container, behind all content.
const Cols = ({ n, className }) => (
  <div className={`container-x absolute inset-0 h-full ${className}`}>
    {Array.from({ length: n }, (_, c) => (
      <div key={c} className={`h-full border-l border-line/40 ${c === n - 1 ? "border-r" : ""}`} />
    ))}
  </div>
);

export const GridBackdrop = () => (
  <div className="pointer-events-none fixed inset-0 -z-10" aria-hidden="true" data-testid="grid-backdrop">
    <Cols n={1} className="grid grid-cols-1 md:hidden" />
    <Cols n={4} className="hidden grid-cols-4 md:grid lg:hidden" />
    <Cols n={6} className="hidden grid-cols-6 lg:grid" />
  </div>
);
